import { render, staticRenderFns } from "./LoginSchool.vue?vue&type=template&id=083adf8b&scoped=true"
import script from "./LoginSchool.vue?vue&type=script&lang=js"
export * from "./LoginSchool.vue?vue&type=script&lang=js"
import style0 from "./LoginSchool.vue?vue&type=style&index=0&id=083adf8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083adf8b",
  null
  
)

export default component.exports